let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("71GDG")).then(() => parcelRequire('7DZU3'));